module.exports = __webpack_public_path__ + "a951699fc5833b0af8d93a6c12566b67.svg";